import React from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  form,
  Form as AppForm,
  FormInput,
  Select,
  FileInput,
  FormTypes
} from "MODULES/shared/components/Forms";
import { ATTACHMENT_TYPE, REFERENCE_NUMBER } from "APP_ROOT/constants";
import { DESCRIPTION } from "MODULES/parts/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { OTHER } from "MODULES/Lots/constants";
import { toOptions } from "LIB/forms";
import { properCase } from "LIB/formatters/text";
import * as actions from "../../actions/attachments";

export function AttachmentForm(props) {
  const { attachmentTypes } = props;
  // Filtering out the 'external_link' key from the attachmentTypes since
  // we need the label for display purposes but do not want it to show up in
  // the dropdown for file-type attachments.
  /* eslint-disable no-unused-vars */
  const { external_link, ...filteredAttachmentTypes } = attachmentTypes;
  /* eslint-enable no-unused-vars */
  const orderedAttachments = Object.keys(filteredAttachmentTypes)
    .sort((a, b) =>
      filteredAttachmentTypes[a].label.localeCompare(
        filteredAttachmentTypes[b].label
      )
    )
    .reduce((obj, key) => {
      obj[key] = filteredAttachmentTypes[key];
      return obj;
    }, {});

  const attachmentOptions = [
    "incoming_quotes",
    "outgoing_quotes",
    "inventories",
    "companies",
    "sales_orders",
    "purchase_orders",
    "outgoing_quotes",
    "incoming_quotes",
    "rmas"
  ].includes(props.resourceType)
    ? filteredAttachmentTypes
    : orderedAttachments;

  const options = toOptions(
    Object.assign(attachmentOptions, {
      other: {
        label: "Other"
      }
    })
  );

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Field
          name={ATTACHMENT_TYPE}
          component={Select}
          label={properCase(ATTACHMENT_TYPE)}
          options={options}
          required
        />
        {props.getFieldValue(ATTACHMENT_TYPE) === OTHER && (
          <Field
            name={DESCRIPTION}
            component={FormInput}
            label={properCase(DESCRIPTION)}
            required
          />
        )}
        {props.referenceOptions &&
          props.referenceOptions.length > 2 && (
            <Field
              name={REFERENCE_NUMBER}
              component={Select}
              label={properCase(REFERENCE_NUMBER)}
              options={props.referenceOptions}
              required
            />
          )}
        <Field
          name="file"
          component={FileInput}
          label="Upload Attachment"
          multiple={props.multiple}
          required
        />
      </AppForm.Body>
    </AppForm>
  );
}

AttachmentForm.propTypes = FormTypes.modalForm;

function validate(values, props) {
  return validator(values, f => {
    f.validate("file", ATTACHMENT_TYPE).satisfies(rules.required);
    if (props.referenceOptions && props.referenceOptions.length > 2) {
      f.validate(REFERENCE_NUMBER).satisfies(rules.required);
    }
    if (values.attachment_type === OTHER) {
      f.validate(DESCRIPTION).satisfies(rules.required);
    }
  });
}

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data => {
    if (ownProps.multiple) {
      return dispatch(
        actions.multiUpload(ownProps.resourceId, ownProps.resourceType, data)
      ).then(() => ownProps.close());
    }
    return dispatch(
      actions.upload(ownProps.resourceId, ownProps.resourceType, data)
    );
  }
}))(
  form({
    form: "attachmentForm",
    validate
  })(withFieldAccessors(AttachmentForm))
);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Attachments/AttachmentForm.jsx